import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import AppRouterProvider from "./routes/AppRouterProvider.tsx";
import "./index.css";
import { Toaster } from "@/components/ui/sonner";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppRouterProvider />
    <Toaster position="bottom-center" />
  </StrictMode>,
);
